import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesSolves: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 9.905h1.53v18.29h-1.53Zm-1.52 18.29h1.52v1.52h-1.52Zm0-19.81h1.52v1.52h-1.52Zm-21.33 21.33h21.33v1.52H5.335Zm15.23-22.86h6.1v1.53h-6.1Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.52-1.52h1.52v1.52h-1.52Zm-3.05-1.52h3.05v1.52h-3.05Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52v3.05h-1.52Zm-3.05 13.72h1.53v3.05h-1.53Zm-1.52 3.05h1.52v1.52h-1.52Zm0-4.58h1.52v1.53h-1.52Zm-1.52-9.14h6.09v1.53h-6.09Zm-1.53 7.62v-4.57h-1.52v6.09h4.57v-1.52zm0 13.72h1.53v1.52h-1.53Zm0-19.81h1.53v1.52h-1.53Zm0 15.23h3.05v-1.52h-4.57v6.1h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesSolves
